import React, { Component } from 'react';
import PropTypes from 'prop-types';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "/* add css styles here (optional) */\n\n.styles_test__32Qsm {\n  display: inline-block;\n  margin: 2em auto;\n  border: 2px solid #000;\n  font-size: 2em;\n}\n";
styleInject(css);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var CollectorCheckout = function (_Component) {
  inherits(CollectorCheckout, _Component);

  function CollectorCheckout(props) {
    classCallCheck(this, CollectorCheckout);

    var _this = possibleConstructorReturn(this, (CollectorCheckout.__proto__ || Object.getPrototypeOf(CollectorCheckout)).call(this, props));

    _this.state = {
      checkoutHeight: 0,
      loading: true
    };

    _this.myRef = React.createRef();
    return _this;
  }

  createClass(CollectorCheckout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      console.log('mounted');
      //   collector;
      window.addEventListener('message', function (e) {
        return _this2.msgHandler(e);
      });
      console.log('ref', this.myRef);
      var node = this.myRef.current;

      // send this up so we can send it down to cart
      // todo send this up somehow so we can send commands?
      if (this.props.nodeRef !== '') {
        // Callback for sending back nodeRef?
        this.props.nodeRef(node);
      }
    }
  }, {
    key: 'msgHandler',
    value: function msgHandler(e) {
      if (_typeof(e.data) === 'object') {
        return;
      }

      var message = e.data;

      console.log('message###', message);

      // const match = message.match('(?<=checkout\\-)[^\\[]+');
      var match = message.match('collector-checkout-(.*?)\\[');

      if (match) {
        if (match[1] && match[1] === 'height-set') {
          var checkoutHeight = message.split('=')[1];
          this.setState({ checkoutHeight: checkoutHeight });
        } else {
          this.props.checkoutUpdate(match[1]);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          dataType = _props.dataType,
          token = _props.token,
          development = _props.development;


      if (token == null) {
        return 'No token presented';
      }

      var checkoutHeight = this.state.checkoutHeight;

      var typeUrl = '';

      if (dataType === 'B2B') {
        typeUrl = '_' + dataType.toLowerCase();
      }

      var checkoutUrl = 'https://checkout' + (development ? '-uat' : '') + '.collector.se/citra/sv-SE' + typeUrl + '.html?token=' + token;

      return React.createElement('iframe', {
        title: 'Collector Checkout',
        ref: this.myRef,
        src: checkoutUrl,
        width: '100%',
        height: checkoutHeight,
        scrolling: 'no',
        frameBorder: '0',
        style: ({ overflow: 'hidden auto' })
      });
    }
  }]);
  return CollectorCheckout;
}(Component);

CollectorCheckout.propTypes = {
  token: PropTypes.string,
  dataType: PropTypes.string,
  development: PropTypes.bool,
  nodeRef: PropTypes.func,
  checkoutUpdate: PropTypes.func
};


CollectorCheckout.defaultProps = {
  nodeRef: '',
  development: false,
  checkoutUpdate: false
};

export default CollectorCheckout;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/collector-checkout/dist/index.es.js
// module id = 91
// module chunks = 0